<template lang="pug">
div
  v-card.elevation-0
    v-toolbar.elevation-0(color='white')
      v-toolbar-title Nieuw wachtwoord

    v-card-text
      p Voer je nieuwe wachtwoord in. Je kan daarna direct inloggen.

      v-form.mt-5
        text-field#password(
          name='password',
          label='Wachtwoord',
          type='password',
          v-model='password',
          @keyup.enter='resetPassword',
          :error-messages='passwordValidationErrors',
          @change='$v.password.$touch()',
          @blur='$v.password.$touch()',
          :append-icon="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
          @click:append='passwordVisible = !passwordVisible',
          :type="passwordVisible ? 'text' : 'password'"
          )

    v-card-actions.pa-4
      v-btn(flat, small, :to='{ name: "login" }') Terug naar loginscherm
      v-spacer
      v-btn(color='primary', @click='resetPassword', :loading='loading', :disabled='$v.$invalid') Bevestigen

</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { regex } from 'vuelidate/lib/validators/common'
import { strongPasswordRegex } from '@/helpers/auth'

export default {
  data () {
    return {
      password: null,
      passwordRepeat: null,
      loading: false,
      token: null,

      passwordVisible: false
    }
  },

  computed: {
    passwordValidationErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Dit veld is verplicht')
      !this.$v.password.strongPassword && errors.push('Wachtwoord moet minimaal 1 kleine letter, 1 hoofdletter, 1 cijfer en 1 speciaal teken bevatten met minimale lengte van 8 tekens.')
      return errors
    }
  },

  methods: {
    async resetPassword () {
      this.loading = true

      try {
        await this.$store.dispatch('auth/resetPassword', {
          token: this.token,
          password: this.password
        })

        this.$root.$snackbar.show('Je wachtwoord is gewijzigd. Je kan nu inloggen.')
      } catch (error) {
        console.error(error)

        await this.$root.$confirm('Fout', 'Er is iets fout gegaan. Misschien is de link in je email verlopen. Probeer een nieuwe aan te vragen. Als dit niet lukt, neem contact met ons op.', { color: 'red', confirmLabel: 'OK', cancelButton: false })
      }

      this.loading = false

      this.$router.push({
        name: 'login'
      })
    }
  },

  async mounted () {
    this.token = this.$route.query.token

    if (!this.token) {
      setTimeout(async () => { // workaround because this gets called before $root.$confirm is set in App.vue
        await this.$root.$confirm('Fout', 'De link die je gebruikt hebt is niet geldig. Probeer een nieuwe aan te vragen.\n\nAls dit niet lukt, neem dan contact op met de DFS supportafdeling.', { color: 'red', confirmLabel: 'OK', cancelButton: false })

        this.$router.push({
          name: 'login'
        })
      }, 10)
    }
  },

  validations: {
    password: {
      required,
      strongPassword: regex('strongPassword', strongPasswordRegex)
    }
  }
}
</script>
